import React from 'react';
import { formControlPropTypes } from './FormControlPropTypes';
const FormControl = /*#__PURE__*/React.forwardRef(({
  children,
  onSubmit,
  classname
}, ref) => /*#__PURE__*/React.createElement("form", {
  className: classname || '',
  onSubmit: onSubmit,
  ref: ref
}, children));
FormControl.propTypes = formControlPropTypes;
export default FormControl;